import { Field } from '@ui/components/Field';
import { PercentIcon } from '@ui/components/Icons';
import { selectQuotePriceField } from '@ui/features/quote-builder/state/selectors/quote-price-field';
import { useSelector } from '@ui/hooks/useSelector';

import { useQuotePriceContext } from './QuotePriceProvider';

/**
 * Used to display the grossMargin as an uneditable field.
 */
export function FinalGrossMargin() {
  const { quoteLineUuid, quotePriceUuid, isFirstQuotePrice } =
    useQuotePriceContext();
  const { value } = useSelector((state) =>
    selectQuotePriceField(state, quoteLineUuid, quotePriceUuid, 'grossMargin'),
  );

  return (
    <Field
      label="Final Gross Margin"
      showLabel={isFirstQuotePrice}
      leftIcon={PercentIcon}
      value={value}
      type="number"
      isDisabled
    />
  );
}
